(function ($) {
 "use strict";

   $( document ).ready(function() { 
    
    /*----------------------------
    jQuery MeanMenu
    ------------------------------ */
        $('nav#dropdown').meanmenu({
        meanScreenWidth: "991",
        meanMenuContainer: ".mobile-menu",
    });	
    /*----------------------------
    wow js active
    ------------------------------ */
        new WOW().init();
    
    /*----------------------------
    top search active
    ------------------------------ */   
        $('.icon_search').on('click', function(e){
        e.preventDefault();
        $('.widget_searchform_content').toggleClass('active');
        });  
    
    /*----------------------------
    top cart active
    ------------------------------ */   
        $('.top-shop-title').on('click', function(e){
            e.preventDefault();
            $('.wish-cart').toggleClass('active');
        });   
    /*----------------------------
    top search active
    ------------------------------ */   
        $('.header-menu-item-icon').on('click', function(e){
            e.preventDefault();
            $('.widget_searchform').toggleClass('active');
        });      
    /*----------------------------
     sticky active
    ------------------------------ */  
    var stickyTop = $('.header-menu').offset().top;
    $(window).on('scroll', function () {
        if ($(window).scrollTop() > stickyTop) {
            $('.header-menu').addClass('stick');
        } else {
            $('.header-menu').removeClass('stick');
        }
    });
    
    /*----------------------------
    features-curosel2 owl active
    ------------------------------ */  
        $(".features-curosel2").owlCarousel({
          autoPlay: false, 
          slideSpeed:2000,
          pagination:false,
          navigation:true,	  
          items : 4,
          /* transitionStyle : "fade", */    /* [This code for animation ] */
          navigationText:["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
          itemsDesktop : [1199,3],
          itemsDesktopSmall : [980,2],
          itemsTablet: [768,1],
          itemsMobile : [479,1],
        }); 
    
    /*----------------------------
    slider-active-two owl active
    ------------------------------ */  
        $(".slider-active-two").owlCarousel({
        autoPlay: false, 
        slideSpeed:2000,
        pagination:false,
        navigation:true,	  
        items : 3,
        /* transitionStyle : "fade", */    /* [This code for animation ] */
        navigationText:["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
        itemsDesktop : [1199,3],
        itemsDesktopSmall : [980,2],
        itemsTablet: [768,1],
        itemsMobile : [479,1],
        }); 
    /*----------------------------
    owlcarousel client-all active
    ------------------------------ */ 
        $(".client-all").owlCarousel({
        items : 1,
        pagination:true,
        navigation:false,
        navigationText:["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"],
        itemsDesktop : [1199,1],
        itemsDesktopSmall : [979,1],
        itemsMobile : [767,1]
        });
    
    /*---------------------
    price slider
    --------------------- */  
	
    $( "#slider-range" ).slider({
        range: true,
        min: 40,
        max: 600,
        values: [ 20, 1560 ],
        slide: function( event, ui ) {
        $( "#amount" ).val( "$" + ui.values[ 0 ] + " - "+ "$" + ui.values[ 1 ] );
        $('input[name="first_price"]').val( "$" + ui.values[0]);
        $('input[name="last_price"]').val( "$" + ui.values[1]);
    },
    });
    $( "#amount" ).val( "$" + $( "#slider-range" ).slider( "values", 0 ) +
    " - "+"$" + $( "#slider-range" ).slider( "values", 1 ) );
    $('input[name="first_price"]').val( "$" + $( "#slider-range" ).slider( "values", 0 ));
    $('input[name="last_price"]').val( "$" + $( "#slider-range" ).slider( "values", 1 ));
    
    
    
    
    /*-------------------------
    checkout showcoupon toggle function
    --------------------------*/
        $( '#showcoupon' ).on('click', function() {
            $( '#checkout_coupon' ).slideToggle(900);
        });
    
    /*-------------------------
    checkout showcoupon toggle function
    --------------------------*/
    $( '#showcoupon2 input' ).on('click', function() {
        $( '#checkout_coupon2' ).slideToggle(900);
    });
    
    /*-------------------------
    checkout showcoupon toggle function
    --------------------------*/
    $( '#showcoupon3' ).on('click', function() {
        $( '#checkout_coupon3' ).slideToggle(900);
    });
    
    /*-------------------------
    checkout one click toggle function
    --------------------------*/
    var checked = $( '.sin-payment input:checked' )
    if(checked){
        $(checked).siblings( '.payment_box' ).slideDown(900);
    };
	 $( '.sin-payment input' ).on('change', function() {
        $( '.payment_box' ).slideUp(900);
        $(this).siblings( '.payment_box' ).slideToggle(900);
    });
    
    
    
    
    
    
    /*-------------------------
    single-product count
    --------------------------*/
    
    
    $(".cart-plus-minus").prepend('<div class="dec qtybutton">-</div>');
     $(".cart-plus-minus").append('<div class="inc qtybutton">+</div>');
     $(".qtybutton").on("click", function() {
      var $button = $(this);
      var oldValue = $button.parent().find("input").val();
      if ($button.text() == "+") {
        var newVal = parseFloat(oldValue) + 1;
      } else {
         // Don't allow decrementing below zero
        if (oldValue > 0) {
       var newVal = parseFloat(oldValue) - 1;
       } else {
       newVal = 0;
        }
        }
      $button.parent().find("input").val(newVal);
     });
    
    
    /*-------------------------
    zoom-img single-product
    --------------------------*/   
    $('.demo4').snipe({
        class: 'zoom',
    });
    
    
    
    
    /*--------------------------
     scrollUp
    ---------------------------- */	
    $(window).on('scroll',function () {
        if($(window).scrollTop()>200) {
            $("#toTop").fadeIn();
        } else {
            $("#toTop").fadeOut();
        }
    });
    $("#toTop").on('click', function() {
        $("html,body").animate({
            scrollTop:0
        }, 500)
    });    
    
   }); 
    
    
 
})(jQuery); 